<template>
  <div id="app">
    <div>
      <div class="app-title">
        <span v-if="queryParams.lang === 'en'">AIP Question and Answer</span>
        <span v-else>AI库问题解答</span>
      </div>
      <div v-bind:class="{ 'app-subtitle2': queryParams.lang === 'en', 'app-subtitle': queryParams.lang !== 'en' }">
        <div>
          <img class="app-img" :src="logo1" alt="" />
        </div>
        <div v-if="queryParams.lang === 'en'" class="headerContent3" >
            AICOOL Question and Answer
        </div>
        <div class="headerContent" v-else>
          <span>AI库问题解答</span>
        </div>
      </div>
      <div class="intelligent-header" @click="openApp">
        <div class="intelligent">
          <div class="item2">
            <span v-if="queryParams.lang === 'en'"
              >Intelligent Guidance Usage</span
            >
            <span v-else>智能引导使用</span>
          </div>
          <div class="item3">
            <span v-if="queryParams.lang === 'en'"
              >AICOOL Function Usage Video Tutorial</span
            >
            <span v-else>AI库功能使用视频操作</span>
          </div>
        </div>
        <div class="intelligent-img-title" v-if="queryParams.lang === 'en'">
          <img :src="logo2" alt="" class="intelligent-img" />
        </div>
        <div class="intelligent-img-title" v-else>
          <img :src="logo2" alt="" class="intelligent-img" />
        </div>
      </div>
      <div class="faq">
        <div v-for="item in list" :key="item.id">
          <div class="faq-h48" @click="clickIcon(item.iconStr, item.id)">
            <span class="contentTitle">{{ item.title }}</span>
            <i
              class="el-icon-arrow-right"
              v-if="item.iconStr === 1"
              style="float: right; padding-top: 14px"
            ></i>
            <i
              class="el-icon-arrow-down"
              v-else
              style="float: right; padding-top: 14px"
            ></i>
          </div>
          <ul v-if="item.iconStr === 2">
            <li
              class="contentItem"
              v-for="item1 in item.children"
              :key="item1.id"
              @click="clickCollapseItem(item1)"
            >
              {{ item1.title }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "FAQ",
  props: {
    msg: String,
  },
  data() {
    return {
      queryParams: "",
      id: "",
      env: process.env.VUE_APP_BASE_API,
      logo1: require("@/assets/FAQLogo.png"),
      logo2: require("@/assets/FAQRight.png"),
      iconStr: 1,
      list: [],
    };
  },
  async mounted() {
    this.queryParams = await this.getQueryParams();
    const url = `${this.env}/v2/public/faq/classify?page=1&limit=20&lang=${
      this.queryParams?.lang || "zh"
    }`;
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "x-api-version": this.queryParams["version"] ?? 0,
          "x-current-platform": this.queryParams["platform"] ?? "all",
          "x-app-channel": this.queryParams["channel"] ?? "defaults",
          "x-current-package": this.queryParams["package"] ?? "",
        },
      })
      .then((res) => {
        if (res.data.data.items && res.data.data.items.length !== 0) {
          this.list = res.data.data.items;
          this.list.forEach((item) => {
            item.iconStr = 1;
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  },
  methods: {
    getQueryParams() {
      const params = {};
      const queryString = window.location.search.substring(1);
      const pairs = queryString.split("&");
      for (let pair of pairs) {
        const [key, value] = pair.split("=");
        params[decodeURIComponent(key)] = decodeURIComponent(value);
      }
      return params;
    },
    openApp() {
      // window.flutter_inappwebview?.callHandler("sendMessage", {
      //   message: "JumpIntelligentGuidance",
      // });
      if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
        window.flutter_inappwebview.callHandler('sendMessage', {
          message: "JumpIntelligentGuidance"
        })
      } else if (window.sendMessage !== undefined) {
        window.sendMessage.postMessage('JumpIntelligentGuidance');
      }else {
        console.log("window.flutter_inappwebview is not defined")
      }
    },
    goBack() {
      // window.flutter_inappwebview?.callHandler("sendMessage", {
      //   message: "JumpHome",
      // });
      if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
        window.flutter_inappwebview.callHandler('sendMessage', {
          message: "JumpHome"
        })
      } else if (window.sendMessage !== undefined) {
        window.sendMessage.postMessage('JumpHome');
      }
    },
    clickCollapseItem(val) {
      this.$router.push({
        path: "/FAQContent",
        query: {
          id: val.id,
        },
      });
      this.id = val.id;
    },
    clickIcon(val, id) {
      this.list.forEach((item) => {
        if (item.id === id) {
          item.iconStr = val === 1 ? 2 : 1;
          this.$forceUpdate();
          const url = `${
            this.env
          }/v2/public/faq/classify/${id}?page=1&limit=999&lang=${
            this.queryParams?.lang || "zh"
          }`;
          axios
            .get(url, {
              headers: {
                "Content-Type": "application/json",
                "x-api-version": this.queryParams["version"] ?? "",
                "x-current-platform": this.queryParams["platform"] ?? "",
                "x-app-channel": this.queryParams["channel"] ?? "",
                "x-current-package": this.queryParams["package"] ?? "",
              },
            })
            .then((res) => {
              if (res.data.data?.items && res.data.data?.items.length !== 0) {
                this.list.forEach((item) => {
                  if (item.id === id) {
                    item.children = res.data.data.items;
                  }
                });
                this.$forceUpdate();
              }
            })
            .catch((error) => {
              console.error(error);
            });
        }
      });
    },
  },
};
</script>

<style scoped>
#app {
  height: 100vh;
  overflow: auto;
}

.app-title {
  margin: -35px auto 24px auto;
  text-align: center;
  z-index: 999;
}

.header {
  font-family: PingFang SC, serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0em;
  /* font-variation-settings: "opsz" 8; */
  /* 文本色 */
  color: #0e273b;
  z-index: 1;
}

.headerContent {
  font-family: PingFang SC, serif;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0em;
  /* font-variation-settings: "opsz" 8; */
  color: #3d3d3d;
  padding-left: 16px;
  height: 48px;
  line-height: 48px;
}

.headerContent2 {
  font-family: PingFang SC, serif;
  font-size: 21px;
  font-weight: 500;
  letter-spacing: 0em;
  /* font-variation-settings: "opsz" 8; */
  color: #3d3d3d;
  padding-left: 0px;
  height: 48px;
  line-height: 48px;
}
.headerContent3{
  font-family: PingFang SC, serif;
  font-size: 21px;
  font-weight: 500;
  /* letter-spacing: 0em; */
  /* font-variation-settings: "opsz" 8; */
  color: #3d3d3d;
  padding-left: 0px;
  height: 48px;
  /* line-height: 48px; */
  text-align: left;
  padding-top: 12px;
}

.app-subtitle {
  font-family: PingFang SC, serif;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0em;
  /* font-variation-settings: "opsz" 8; */
  color: #3d3d3d;
  display: flex;
  text-align: left;
  height: 48px;
  line-height: 48px;
  margin-bottom: 16px;
}
.app-subtitle2{
  font-family: PingFang SC, serif;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0em;
  /* font-variation-settings: "opsz" 8; */
  color: #3d3d3d;
  display: flex;
  text-align: left;
  height: 48px;
  /* line-height: 48px; */
  margin-bottom: 16px;
}

.app-img {
  width: 48px;
  height: 48px;
  border-radius: 28px;
}

.collapseItem {
  text-align: left;
  font-family: PingFang SC, serif;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0em;
  /* font-variation-settings: "opsz" 8; */
  color: #f65e3d;
  padding: 24px 0px 0px 20px;
}

.item2 {
  font-family: PingFang SC, serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  /* font-variation-settings: "opsz" 8; */
  /* 品牌色 */
  color: #f65e3d;
  text-align: left;
  margin-bottom: 4px;
}

.item3 {
  font-family: PingFang SC, serif;
  font-size: 12px;
  font-weight: normal;
  line-height: 16px;
  letter-spacing: 0em;
  /* font-variation-settings: "opsz" 8; */
  /* 正文色/正文辅助色 */
  color: #767676;
  text-align: left;
}

::v-deep .el-collapse-item__header,
::v-deep .el-collapse-item__wrap {
  border-radius: 10px;
  padding-left: 16px;
  font-family: PingFang SC, serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;
  /* font-variation-settings: "opsz" 8; */
  /* 文本色 */
  color: #0e273b;
}

ul li {
  list-style: none;
}

.contentTitle {
  font-family: PingFang SC, serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;
  /* font-variation-settings: "opsz" 8; */
  /* 文本色 */
  color: #0e273b;
  z-index: 1;
}

.contentItem {
  font-family: PingFang SC, serif;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0em;
  /* font-variation-settings: "opsz" 8; */
  color: #f65e3d;
  padding: 14px 4px 10px 4px;
}

.intelligent {
  flex: 1;
  padding: 16px 0px 16px 24px;
}

.intelligent-header {
  display: flex;
  height: 76px;
  border-radius: 24px;
  margin-bottom: 16px;
  background: #fff;
}

.intelligent-title {
  padding: 16px 0px 16px 50px;
}

.intelligent-img {
  width: 44px;
  height: 44px;
}

.intelligent-img-title {
  padding: 16px;
}

.faq {
  border-radius: 24px;
  margin: 24px auto 0px;
  border-radius: 24px;
  background: #ffffff;
  text-align: left;
  padding: 16px;
}

.faq-h48 {
  height: 48px;
  line-height: 48px;
}
</style>
